import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import useIsTF911Enabled from '../../../hooks/useIsTF911Enabled';
import useShouldRenderAgencyShareChat from '../../../hooks/useShouldRenderAgencyShareChat';
import useShouldRenderTF911 from '../../../hooks/useShouldRenderTF911';
import AgencyShareChatBox from './AgencyShareChat/ASCChatBox';
import TF911ChatBox from './TF911ChatBox/TF911ChatBox';

export const CHAT_SOURCE_ASC = 'asc';
export const CHAT_SOURCE_TF911 = 'tf911';

const CallChats = ({
  isAgencyShareChatChatBoxVisible,
  isTextFrom911ChatBoxVisible,
  onCollapseChat,
}) => {
  const shouldRenderAgencyShareChat = useShouldRenderAgencyShareChat();

  const isTF911Enabled = useIsTF911Enabled();

  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );

  const shouldRenderTF911 = useShouldRenderTF911(selectedCallerID);

  // For styling
  const bothChatsEnabled =
    shouldRenderAgencyShareChat && isTF911Enabled && shouldRenderTF911;

  return (
    <Box data-name="call-chats" height="100%" overflowY="auto">
      {isTF911Enabled && shouldRenderTF911 && (
        <TF911ChatBox
          bothChatsEnabled={bothChatsEnabled}
          isTextFrom911ChatBoxVisible={isTextFrom911ChatBoxVisible}
          maxContainerHeight
          onCollapseChat={onCollapseChat}
        />
      )}
      {shouldRenderAgencyShareChat && (
        <AgencyShareChatBox
          bothChatsEnabled={bothChatsEnabled}
          isAgencyShareChatChatBoxVisible={isAgencyShareChatChatBoxVisible}
          onCollapseChat={onCollapseChat}
        />
      )}
    </Box>
  );
};

export default CallChats;
